import api from "./axiosConfig";

/*
 * Backend contract:
 * POST /api/users/{userId}/report { reason?: string }
 * POST /api/users/{userId}/block  { reason?: string }
 * Both return 201 { targetUserId, action, status: "ACTIVE" }.
 * Welcome messages expose aiGenerated and aiDisclosure fields; the backend
 * prefixes automated welcome content with "Wiadomość powitalna od AI:".
 */
export function reportUser({ reportedUserId, reason, details }) {
  const normalizedReason = details
    ? `${reason}\n\nDodatkowe informacje:\n${details}`
    : reason;
  return api.post(`/api/users/${reportedUserId}/report`, { reason: normalizedReason });
}

export function blockUser(blockedUserId) {
  return api.post(`/api/users/${blockedUserId}/block`, {});
}
